export const colorTokens = {
  brand: { 50: '#e9f8fa', 100: '#cdeff2', 500: '#0ea5b4', 700: '#0e6881', 900: '#092b53' },
  neutral: {
    0: '#ffffff',
    50: '#f5f8fa',
    100: '#eaf0f3',
    300: '#c4d0d8',
    600: '#526779',
    800: '#203b55',
    950: '#0f2b4e',
  },
  info: { surface: '#e9f8fa', border: '#79cdd4', text: '#075a68' },
  success: { surface: '#f2f7e2', border: '#aec958', text: '#486000' },
  warning: { surface: '#fff4d6', border: '#e3bf62', text: '#674b00' },
  error: { surface: '#ffeded', border: '#e4a1a1', text: '#8f2020' },
} as const;

export const semanticColors = {
  canvas: colorTokens.neutral[50],
  surface: colorTokens.neutral[0],
  surfaceMuted: colorTokens.neutral[100],
  text: colorTokens.neutral[950],
  textMuted: colorTokens.neutral[600],
  border: colorTokens.neutral[300],
  accent: colorTokens.brand[500],
  accentStrong: colorTokens.brand[700],
  focus: '#0e6881',
  disabledSurface: '#e2e7e5',
  disabledText: '#4f5c58',
  info: colorTokens.info,
  success: colorTokens.success,
  warning: colorTokens.warning,
  error: colorTokens.error,
} as const;

export const typographyTokens = {
  fontFamily: {
    sans: "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    mono: "'SFMono-Regular', Consolas, 'Liberation Mono', monospace",
  },
  fontSize: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.25rem',
    xl: '1.75rem',
    display: 'clamp(2.25rem, 5vw, 4.75rem)',
  },
  lineHeight: { tight: 1.1, normal: 1.5, relaxed: 1.7 },
  fontWeight: { regular: 400, medium: 600, bold: 750 },
} as const;

export const spaceTokens = {
  0: '0',
  1: '0.25rem',
  2: '0.5rem',
  3: '0.75rem',
  4: '1rem',
  6: '1.5rem',
  8: '2rem',
  12: '3rem',
  16: '4rem',
} as const;
export const radiusTokens = {
  sm: '0.375rem',
  md: '0.75rem',
  lg: '1.125rem',
  pill: '999px',
} as const;
export const borderTokens = { subtle: '1px solid #c9d2cf', strong: '2px solid #53635f' } as const;
export const shadowTokens = {
  sm: '0 1px 3px rgb(17 27 24 / 0.12)',
  md: '0 12px 32px rgb(17 27 24 / 0.10)',
} as const;
export const sizeTokens = {
  controlSm: '2rem',
  controlMd: '2.75rem',
  content: '80rem',
  readable: '68ch',
  touchTarget: '2.75rem',
} as const;
export const motionTokens = {
  durationFast: '120ms',
  durationNormal: '220ms',
  easingStandard: 'cubic-bezier(0.2, 0, 0, 1)',
} as const;

export const tokens = {
  color: colorTokens,
  semantic: semanticColors,
  typography: typographyTokens,
  space: spaceTokens,
  radius: radiusTokens,
  border: borderTokens,
  shadow: shadowTokens,
  size: sizeTokens,
  motion: motionTokens,
} as const;
export type UrbanikTokens = typeof tokens;
